export default "__VITE_ASSET__WAv8HJNr__"